<template>
  <!-- 顶部横幅：品牌新闻 / NEWS CENTER -->
  <div class="news-hero">
    <div class="news-hero-inner">
      <div class="news-hero-title">
        <span class="zh">品牌新闻</span>
        <span class="en">/ NEWS CENTER</span>
      </div>
    </div>
  </div>

  <!-- 复刻 About.vue 的新闻模块结构 -->
  <section class="news-section">
    <div class="news-container">
      

      <!-- 新闻列表：PC 两列、移动端一列 -->
      <div class="news-list">
        <router-link
          v-for="(news, index) in newsList"
          :key="index"
          :to="news.link"
          class="news-item"
          tag="div"
        >
          <div class="news-image-wrapper">
            <img :src="news.image" :alt="news.title" class="news-image" />
          </div>
          <div class="news-content">
            <h3 class="news-title">{{ news.title }}</h3>
            <p class="news-summary">{{ news.summary }}</p>
            <div class="news-meta">
              <span class="news-date">{{ news.date }}</span>
              <span class="news-views">👁 {{ news.views }}{{ $t("about.look") }}</span>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import newsThumb1 from '@/assets/images/新闻缩略图1.jpg'
import newsThumb2 from '@/assets/images/新闻缩略图2.jpg'
import newsThumb3 from '@/assets/images/新闻缩略图3.jpg'
import news24fwThumb from '@/assets/images/allnews/news24fw/新闻封面图.jpg'
import news2025ssThumb from '@/assets/images/allnews/2025ss/春夏联名.jpg'
import newsThumbsupThumb from '@/assets/images/allnews/Thumbsup/助力火箭.jpg'
import newsBjwoThumb from '@/assets/images/allnews/bjwo/冬奥会.jpg'
import sunwayThumb from '@/assets/images/sunwaystore/3.jpg'
import fw2526Thumb from '@/assets/images/2526FW/1.jpg'
import klccThumb from '@/assets/images/CABBEEN&2AM klcc/图片1.png'
import thirdStoreThumb from '@/assets/images/Thirdstoreopen/1.jpg'

export default {
  name: 'News',
  setup() {
    const { t, locale, getLocaleMessage } = useI18n()
    const thumbs = [newsThumb1, newsThumb2, newsThumb3, news24fwThumb, news2025ssThumb, newsThumbsupThumb, newsBjwoThumb]
    const links = ['/news/malaysia', '/news/hk-listing', '/news/ny-show', '/news/2024-fw', '/news/2025-ss', '/news/thumbsup', '/news/bjwo']
    const dates = ['2025-06-08', '2013-10-28', '2007-02-03', '2024-10-26', '2024-12-13', '2024-03-20', '2024-01-26']
    const views = [835, 1210, 1985, 1182, 962, 881, 1352]

    const sunwayTitle = computed(() => (
      locale.value === 'zh'
        ? 'CABBEEN 于吉隆坡 Sunway Velocity 呈献马来西亚第二家门店'
        : 'CABBEEN presents its second store in Malaysia at Sunway Velocity, Kuala Lumpur'
    ))
    const sunwaySummary = computed(() => (
      locale.value === 'zh'
        ? '继首次登陆马来西亚并于 Bukit Jalil 开设首店后，CABBEEN 持续拓展其国际版图。2025年8月9日，品牌于吉隆坡 Sunway Velocity 正式启幕第二家门店.....'
        : 'Following its first entry into Malaysia and the opening of its first store at Bukit Jalil, CABBEEN continues to expand its international presence. On August 9, 2025, the brand officially launched its second store at Sunway Velocity in Kuala Lumpur.'
    ))

    const fw2526Title = computed(() => (
      locale.value === 'zh'
        ? '25/26 FW /「踏山海 · 共潮生」秋冬时装发布会'
        : "25/26 FW / 'Stepping on Mountains and Seas · Growing Together with the Tide' Autumn/Winter Fashion Show"
    ))
    const fw2526Summary = computed(() => (
      locale.value === 'zh'
        ? '在泉州石狮，海洋从来不仅是自然的背景，更是孕育生计、积淀文化与寄托精神的源头'
        : 'In Shishi, Quanzhou, the ocean has never been just a natural backdrop; it is also a source that nurtures livelihoods, accumulates culture, and carries spiritual significance.'
    ))

    const klccTitle = computed(() => (
      locale.value === 'zh'
        ? 'CABBEEN卡宾携2AM限时快闪登陆吉隆坡'
        : 'CABBEEN brings 2AM to Kuala Lumpur for a limited-time pop-up event.'
    ))
    const klccSummary = computed(() => (
      locale.value === 'zh'
        ? '3月4日，中国时尚男装品牌CABBEEN卡宾携旗下年轻化街头品牌2AM，登陆吉隆坡升禧广场，开启为期五天的限时快闪体验，融合时尚、科技与文化。'
        : "On March 4th, Chinese menswear fashion brand CABBEEN, along with its youthful streetwear brand 2AM, launched a five-day pop-up experience at Kuala Lumpur's Grand Gateway Plaza....."
    ))

    const thirdStoreTitle = computed(() => (
      locale.value === 'zh'
        ? 'CABBEEN卡宾马来西亚第三家门店正式开幕子品牌2AM首次登陆大马'
        : 'CABBEEN Malaysia Opens Third Store in Malaysia, Marking the Debut of Sub-Brand 2AM'
    ))
    const thirdStoreSummary = computed(() => (
      locale.value === 'zh'
        ? '2026年8月7日，潮流男装品牌 CABBEEN 卡宾 于马来西亚吉隆坡谷中城美佳广场（Mid Valley Megamall）正式开设马来西亚第三家门店....'
        : '7 August 2026, Kuala Lumpur, Malaysia — Contemporary menswear brand CABBEEN has officially opened its third store in Malaysia at Mid Valley Megamall, marking another milestone....'
    ))

    const newsList = computed(() => {
      const cards = getLocaleMessage(locale.value).news?.cards || []
      const base = cards
        .slice(0, 7)
        .map((card, i) => ({
          ...card,
          image: thumbs[i],
          link: links[i],
          date: dates[i],
          views: views[i]
        }))

      // 合并 Sunway 新闻项参与排序
      base.push({
        title: sunwayTitle.value,
        summary: sunwaySummary.value,
        image: sunwayThumb,
        link: '/news/sunway',
        date: '2025-08-09',
        views: 1233
      })

      // 合并 25/26 FW 新闻项参与排序（确保最新置顶）
      base.push({
        title: fw2526Title.value,
        summary: fw2526Summary.value,
        image: fw2526Thumb,
        link: '/news/2526-fw',
        date: '2025-09-17',
        views: 1055
      })

      base.push({
        title: klccTitle.value,
        summary: klccSummary.value,
        image: klccThumb,
        link: '/news/cabbeen-2am-klcc',
        date: '2026-03-04',
        views: 2839
      })

      base.push({
        title: thirdStoreTitle.value,
        summary: thirdStoreSummary.value,
        image: thirdStoreThumb,
        link: '/news/third-store-open',
        date: '2026-08-07',
        views: 2154
      })

      return base.sort((a, b) => new Date(b.date) - new Date(a.date))
    })

    return { t, newsList, sunwayTitle, sunwaySummary, klccTitle, klccSummary }
  }
}
</script>

<style scoped>
/* 顶部横幅样式 */
.news-hero {
  position: relative;
  width: 100%;
  height: 230px;
  background: url('~@/assets/images/关于卡宾背景图.jpg') center/cover no-repeat;
}
.news-hero::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(26,26,26,0.65); /* 半透明遮罩，贴近截图效果 */
}
.news-hero-inner {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.news-hero-title { color: #fff; font-weight: 700; letter-spacing: 1px; }
.news-hero-title .zh { font-size: 22px; margin-right: 10px; }
.news-hero-title .en { font-size: 22px; color: #ffb100; }

/* 复制 About.vue 的新闻样式，确保视觉一致 */
.news-section {
  background: #000;
  padding: 80px 20px;
  color: white;
}

.news-container {
  max-width: 1600px;
  margin: 0 auto;
}

.news-title {
  font-size: 2.4rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 50px;
  line-height: 1.6;
}
.news-title .zh { color: white; font-size: 25px; }
.news-title .en { color: #ffb100; margin-left: 10px; font-size: 25px; }

.news-list {
  display: grid;
  grid-template-columns: repeat(2, 550px); /* PC 两列固定卡片宽度，整体可水平居中 */
  justify-content: center; /* 让两列整体在容器中居中 */
  column-gap: 40px; /* 同一行内两卡片的水平间距 */
  row-gap: 32px; /* 行与行之间的垂直间距 */
  padding: 20px 0;
  box-sizing: border-box;
}

.news-item {
  background: #1c1c1c;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  width: 100%;
  max-width: 100%;
  margin: 0;  /* 由网格控制间距，不再自居中 */
  padding: 20px; /* 减少内边距，让图片更大 */
}

.news-image-wrapper {
  width: 100%;
  height: 360px; /* 提升图片高度，接近示例效果 */
  overflow: hidden;
  margin-bottom: 16px;
}
.news-image { width: 100%; height: 100%; object-fit: cover; transition: transform 0.3s ease; }
.news-image:hover { transform: scale(1.05); }

.news-content { padding: 16px; display: flex; flex-direction: column; flex-grow: 1; }
.news-title { font-size: 18px; font-weight: bold; color: #ffb100; line-height: 1.5; margin-bottom: 10px; }
.news-summary { font-size: 13px; color: #ccc; line-height: 1.6; flex-grow: 1; margin-bottom: 15px; }
.news-meta { display: flex; justify-content: space-between; font-size: 12px; color: #888; border-top: 1px solid rgba(255,255,255,0.1); padding-top: 10px; }

@media (max-width: 768px) {
  .news-list {
    grid-template-columns: 1fr; /* 移动端一列 */
    column-gap: 16px; /* 移动端同一行内水平间距 */
    row-gap: 16px; /* 移动端行间距 */
    padding: 0 10px;
  }
  .news-item { margin: 10px auto; max-width: 100%; }
  .news-title { font-size: 18px; }
  .news-summary { font-size: 14px; }
  .news-title .zh, .news-title .en { font-size: 22px; }
}
</style>

